/* eslint-disable camelcase */
/* eslint-disable @nfq/sort-keys */

export const CONTACT_STATE = {
    notContacted: 'Nicht kontaktiert',
    notReached: 'Nicht erreicht',
    contacted: 'Kontaktiert',
    meetingScheduled: 'Termin vereinbart',
    isClient: 'Als Kunde gewonnen'
};

export const AGE_CATEGORIES = [
    {
        from: 0,
        to: 20,
        name: '< 20'
    },
    {
        from: 20,
        to: 30,
        name: '20 - 30'
    },
    {
        from: 30,
        to: 40,
        name: '30 - 40'
    },
    {
        from: 40,
        to: 50,
        name: '40 - 50'
    },
    {
        from: 50,
        to: 60,
        name: '50 - 60'
    },
    {
        from: 60,
        to: 999,
        name: '60+'
    }
];

export const CONTACT_METHOD = {
    email: 'E-Mail',
    phone: 'Telefon'
};

export const VERIFIED = {
    verified: 'Verifiziert',
    not_verified: 'Nicht Verifiziert'
};

export const GENDER = {
    female: 'Weiblich',
    male: 'Männlich',
    other: 'Divers'
};

export const BUDGET_CATEGORY = {
    any: 'Egal',
    budget_low: '450 - 990€',
    budget_mid: '991 - 1990€',
    budget_high: '> 1990€'
};

export const HAIRLOSS_REASON = {
    reason1: 'Chemotherapie',
    reason2: 'Diffuser Haarausfall',
    reason3: 'Kreisrunder Haarausfall',
    reason4: 'Erblich bedingter Haarausfall',
    other: 'Weiß nicht'
};

export const FOR_CATEGORY = {
    myself: 'Für mich',
    otherPerson: 'Andere Person'
};

export const PRODUCT_CATEGORY = {
    hairpiece: 'Haarteil',
    toupee: 'Haarersatz für Männer (Toupet)',
    wig: 'Perücke',
    other: 'Weiß nicht'
};

export const CHART_PRODUCT_CATEGORY = {
    hairpiece: 'Haarteil',
    toupee: 'Toupet',
    wig: 'Perücke',
    other: 'Weiß nicht'
};

export const PRODUCT_SERVICE = {
    cleaning: 'Reinigung',
    repair: 'Reparatur'
};

export const HAIRLOSS_INTENSITY = {
    step1: 'Stufe 1',
    step2: 'Stufe 2',
    step3: 'Stufe 3',
    step4: 'Stufe 4',
    step5: 'Stufe 5',
    step6: 'Stufe 6',
    step7: 'Stufe 7',
    step8: 'Glatze'
};

export const PRODUCT_EXPERIENCE = {
    wig: 'Perücke',
    toupee: 'Toupet',
    hairpiece: 'Haarteil',
    extensions: 'Extensions',
    none: 'Keine'
};

export const PRODUCT_STYLING = {
    yes: 'Ja',
    no: 'Nein',
    other: 'Egal'
};

export const PRODUCT_HAIR_LENGTH = {
    short: 'Kurz',
    medium: 'Mittel',
    long: 'Lang',
    other: 'Egal'
};

export const PRODUCT_HAIR_COLOR = {
    color1: 'Hellblond',
    color2: 'Mittelblond',
    color3: 'Dunkelblond',
    color4: 'Hellbraun',
    color5: 'Kastanienbraun',
    color6: 'Rotbraun',
    color7: 'Dunkelbraun',
    color8: 'Schwarz',
    color9: 'Grau'
};

export const PRODUCT_USE_FREQUENCY = {
    always: 'Täglich',
    special: 'Zu bestimmten Anlässen',
    other: 'Weiß nicht'
};

export const PRODUCT_URGENCY = {
    asap: 'Schnellstmöglich',
    aFewWeeks: '3 - 4 Wochen',
    other: 'Es eilt nicht'
};

/**
 * Return array of choices for React Admin SelectInput
 *
 * @param {Object} choiceDict The dict
 * @param {Array} excludeIds List of ids to exclude from the result
 * @returns {Array} Array of choices
 */
export function choices(choiceDict, excludeIds = []) {
    return Object.entries(choiceDict)
        .filter(([key]) => excludeIds.includes(key) === false)
        .map(([key, value]) => {
            let name = value;

            if (typeof value === 'object') {
                name = value.name;
            }

            return {
                id: key,
                name
            };
        });
}